const e = (s) => `data:image/svg+xml,${encodeURIComponent(s)}`;

// Animaciones de los ejercicios, servidas por jsDelivr desde un repositorio
// público de GitHub. Los identificadores (0025, 0047...) son los mismos que usa
// public/data/exercises.json, así que un ejercicio de la biblioteca y uno de la
// rutina por defecto apuntan al mismo GIF.
export const GIF_BASE =
  "https://cdn.jsdelivr.net/gh/hasaneyldrm/exercises-dataset@main/videos/";

// ─── Rutina por defecto ───────────────────────────────────────────────────────

let _id = 0;
const uid = () => `${Date.now()}-${_id++}`;

export const DEFAULT_ROUTINE = [
  {
    name: "Día 1 · Empuje",
    short: "D1",
    exercises: [
      {
        id: uid(), libraryId: "0025", name: "Press banca", muscleGroup: "Pecho",
        sets: 3, reps: "8-12", img: GIF_BASE + "0025-EIeI8Vf.gif",
        variants: [
          { name: "Press inclinado", libraryId: "0047", img: GIF_BASE + "0047-3TZduzM.gif" },
          { name: "Press inclinado mancuernas", libraryId: "0314", img: GIF_BASE + "0314-ns0SIbU.gif" },
        ],
      },
      {
        id: uid(), libraryId: "0596", name: "Contractora pecho", muscleGroup: "Pecho",
        sets: 3, reps: "12-15", img: GIF_BASE + "0596-v3xmPAR.gif",
        variants: [
          { name: "Cruce poleas", libraryId: "0155", img: GIF_BASE + "0155-0CXGHya.gif" },
        ],
      },
      {
        id: uid(), libraryId: "0251", name: "Fondos", muscleGroup: "Pecho/Tríceps",
        sets: 3, reps: "Al fallo", img: GIF_BASE + "0251-9WTm7dq.gif",
        variants: [
          { name: "Flexiones pica", libraryId: "3662", img: GIF_BASE + "3662-XPUDTt7.gif" },
        ],
      },
      {
        id: uid(), libraryId: "0334", name: "Elevaciones laterales", muscleGroup: "Hombros",
        sets: 3, reps: "12-15", img: GIF_BASE + "0334-DsgkuIt.gif",
      },
      {
        id: uid(), libraryId: "0241", name: "Tríceps polea", muscleGroup: "Tríceps",
        sets: 3, reps: "12-15", img: GIF_BASE + "0241-gAwDzB3.gif",
        variants: [
          { name: "Barra Z", libraryId: "2406", img: GIF_BASE + "2406-ThKP69G.gif" },
        ],
      },
    ],
  },
  {
    name: "Día 2 · Tirón",
    short: "D2",
    exercises: [
      {
        id: uid(), libraryId: "0861", name: "Remo polea", muscleGroup: "Espalda",
        sets: 3, reps: "10-12", img: GIF_BASE + "0861-fUBheHs.gif",
      },
      {
        id: uid(), libraryId: "2330", name: "Jalón al pecho", muscleGroup: "Espalda",
        sets: 3, reps: "10-12", img: GIF_BASE + "2330-LEprlgG.gif",
      },
      {
        id: uid(), libraryId: "0220", name: "Encogimientos trapecios", muscleGroup: "Trapecio",
        sets: 3, reps: "12-15", img: GIF_BASE + "0220-Eg98Ft9.gif",
      },
      {
        id: uid(), libraryId: "0240", name: "Hombro posterior polea", muscleGroup: "Hombro posterior",
        sets: 3, reps: "12-15", img: GIF_BASE + "0240-PQcUlDi.gif",
      },
      {
        id: uid(), libraryId: "0294", name: "Bíceps (el que quieras)", muscleGroup: "Bíceps",
        sets: 3, reps: "10-12", img: GIF_BASE + "0294-NbVPDMW.gif",
      },
    ],
  },
  {
    name: "Día 3 · Pierna",
    short: "D3",
    exercises: [
      {
        id: uid(), libraryId: "2287", name: "Prensa", muscleGroup: "Cuádriceps",
        sets: 3, reps: "10-12", img: GIF_BASE + "2287-V07qpXy.gif",
      },
      {
        id: uid(), libraryId: "0585", name: "Curl cuádriceps", muscleGroup: "Cuádriceps",
        sets: 3, reps: "12-15", img: GIF_BASE + "0585-my33uHU.gif",
      },
      {
        id: uid(), libraryId: "0586", name: "Curl femoral", muscleGroup: "Isquiotibiales",
        sets: 3, reps: "12-15", img: GIF_BASE + "0586-17lJ1kr.gif",
      },
      {
        id: uid(), libraryId: "0336", name: "Zancadas con mancuernas", muscleGroup: "Piernas",
        sets: 3, reps: "10-12 por pierna", img: GIF_BASE + "0336-RRWFUcw.gif",
      },
      {
        id: uid(), libraryId: "0605", name: "Gemelo (opcional)", muscleGroup: "Gemelos",
        sets: 3, reps: "15-20", img: GIF_BASE + "0605-ykUOVze.gif",
      },
    ],
  },
];

// Las opciones intercambiables de un ejercicio, como lista indexable.
//
// El índice elegido se guarda en state.alternatives, así que el orden importa:
// la posición 0 es siempre el ejercicio base. Soporta también el modelo antiguo,
// donde las alternativas venían en el nombre separadas por " / " y compartían
// una única imagen — rutinas ya guardadas por usuarios siguen ese formato.
export function getExerciseOptions(exercise) {
  if (Array.isArray(exercise.variants) && exercise.variants.length > 0) {
    return [
      { name: exercise.name, libraryId: exercise.libraryId, img: exercise.img },
      ...exercise.variants,
    ];
  }

  const parts = exercise.name.split(" / ").map((s) => s.trim()).filter(Boolean);
  if (parts.length > 1) {
    return parts.map((name) => ({ name, libraryId: exercise.libraryId, img: exercise.img }));
  }

  return null;
}

export const newExerciseId = uid;
export const DEFAULT_IMAGE = e(`<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 800 400">
<defs><linearGradient id="bg" x1="0" y1="0" x2="1" y2="1">
  <stop offset="0%" stop-color="#0D0F1A"/><stop offset="100%" stop-color="#141826"/>
</linearGradient></defs>
<rect width="800" height="400" fill="url(#bg)"/>
<circle cx="400" cy="200" r="60" fill="none" stroke="#0A85FF" stroke-width="2" opacity="0.4"/>
<circle cx="400" cy="200" r="30" fill="none" stroke="#0A85FF" stroke-width="2" opacity="0.25"/>
</svg>`);
